export const Footer = () => {
    const year = new Date().getFullYear();
    const links = [
        { label: "About", href: "#about" },
        { label: "Services", href: "#services" },
        { label: "Contact", href: "#contact" },
        { label: "Privacy", href: "/privacy-policy" },
        { label: "Terms", href: "/terms" },
    ];

    return (
        <footer
            data-testid="site-footer"
            className="border-t border-slate-200 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div className="flex items-center gap-3">
                    <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-blue-700 text-white text-xs font-bold">
                        N
                    </span>
                    <div>
                        <div className="font-display font-bold text-slate-900">
                            NextGen Systems
                        </div>
                        <div className="text-xs text-slate-500 mt-0.5">
                            Empowering Future Technologies
                        </div>
                    </div>
                </div>

                <nav className="flex flex-wrap items-center gap-x-8 gap-y-3">
                    {links.map((l) => (
                        <a
                            key={l.label}
                            href={l.href}
                            data-testid={`footer-link-${l.label.toLowerCase()}`}
                            className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div
                    data-testid="footer-copyright"
                    className="text-xs text-slate-400"
                >
                    © 2024 NextGen Systems. All rights reserved.
                </div>
            </div>
        </footer>
    );
};
